import { render, staticRenderFns } from "./MobLangSwitch.vue?vue&type=template&id=16855e83&scoped=true"
import script from "./MobLangSwitch.vue?vue&type=script&lang=js"
export * from "./MobLangSwitch.vue?vue&type=script&lang=js"
import style0 from "./MobLangSwitch.vue?vue&type=style&index=0&id=16855e83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16855e83",
  null
  
)

export default component.exports